export default "__VITE_ASSET__51677f26__"